module.exports = __webpack_public_path__ + "static/WhenThePastWasAround4-9f9dfbcbc452d99a4703da05618ebe88.webp";